import styles from './TravelInfoTeaser.module.scss'
import { Card, Col, Row } from 'react-bootstrap'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { TravelFilterTravel } from '@/features/travelFilter/types'
import CloudinaryImage from '@/components/elements/media/CloudinaryImage'
import mediaFileObject from '@/entities/mediaFile/interface'
import { formatPrice } from '@/lib/helpers/helpers'
import { buildFilterTravelDatesLabel } from '@/lib/helpers/travel'
import CardButton from '@/components/elements/buttons/CardButton'

interface Props {
  travel: TravelFilterTravel
  trackingStringPrefix: string
}
const TravelInfoTeaser = ({ travel, trackingStringPrefix }: Props) => {
  const { t } = useTranslation('common')

  return (
    <>
      <Card className={styles.card + ' an-up'} data-tr-view={`${trackingStringPrefix}_travel_teaser:view`}>
        <Link href={`/tour/${travel.urlSlug}`} passHref>
          <a className="img-ratio-16-9" data-tr-click={`${trackingStringPrefix}_travel_teaser:click`}>
            <CloudinaryImage
              image={travel.mainImage as mediaFileObject}
              aspectRatio={1.777}
              width={750}
              responsive={false}
              lazyload={true}
              placeholder={true}
              altDefault={travel.name}
              className={'card-img'}
              placeholderClassName={'position-absolute'}
            />
          </a>
        </Link>
        <Card.Body className={styles.body} data-tr-click={`${trackingStringPrefix}_teaser_text:click_wrong`}>
          <Row>
            <Col xs={12} className={styles.mainInfo}>
              <Card.Title className={styles.title}>{travel.name}</Card.Title>
              <Card.Text as={'div'} className={styles.text}>
                <div className={styles.date}>{buildFilterTravelDatesLabel(travel, t)}</div>
                <div className={styles.tourGuide}>{travel.travelGuides[0] ? `${t('with')} ${travel.travelGuides[0].fullName}` : ''}</div>
                <div className={styles.price}>{`${t('booking.priceFrom')} ${formatPrice(travel.minPrice, travel.currency)}`}</div>
              </Card.Text>
            </Col>
            <Col className={styles.highlights}>
              <ul>
                {travel.highlights.map((highlight, index: number) => (
                  <li key={index}>{highlight.text}</li>
                ))}
              </ul>
            </Col>
          </Row>
        </Card.Body>
        <CardButton label={t('furtherInformation')} href={`/tour/${travel.urlSlug}`} className={styles.linkBtn} />
      </Card>
    </>
  )
}

export default TravelInfoTeaser
